
import React, { useEffect, useState, Fragment } from 'react'
import {Button, Card, Col, Container, Form, Row, Modal} from 'react-bootstrap'
import { Auth, LoadingComponent } from 'recupero-comunes';
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import {validationSchemasSolicitarInformeProfesional} from '../../../common/validation-Schemas-Solicitar-Informe';
import { serviceGetGestores, serviceGetRequisitos, serviceGestionaSolicitudInforme} from '../../../api/api-solicitar-informe-profesional.js';
import { obtenerTareasPendientes } from '../../../store/actions/administracion-caso-action';
import Mensajes from '../../mensajes.js'
import Requisitos from './requisitos.js';
import {CarpetaDigitalComponent} from 'defcol-caso-general'

const Formulario = ({showModal, setShowModal, solicitud, idTrxOrigen, onTareaGestionada}) => {

    const dispatch = useDispatch();
    const TIPO_INFORME_RAT = 299002;
    
    const [loading, setLoading] = useState(false);
    const [cfg_form, setCfg_form] = useState(null);

    const data_encargado = useSelector((state) => state.encargadoCompaniaReducer);
    const {llaves} = data_encargado;

    const [observaciones, setObservaciones] = useState("");

    const [showToast, setShowToast] = useState(false);
    const handleShowToast = () => setShowToast(true) 
    const [respuestaGestion, setRespuestaGestion] = useState({});

    const [gestores, setGestores] = useState([]);
    const[requisitos, setRequisitos]=useState([])

    const handleClose = () => {
        setShowModal(false);
    }
    const handleCloseToast = () => {
        setShowToast(false);
        handleLimpiar();
        setShowModal(false);
        // Solo una gestión exitosa marca la tarea como en proceso; ante error se conserva el
        // comportamiento previo (recarga simple) y el botón sigue activo para reintentar.
        if (onTareaGestionada && respuestaGestion?.code === 1) onTareaGestionada();
        else reloadTareasPendientes();
    }
    const reloadTareasPendientes = () => {
        let query = Buffer.from(JSON.stringify({ idCaso: llaves?.idCaso, idUsuario: Auth.currentUser().rutUsuario })).toString('base64');
        dispatch(obtenerTareasPendientes(query));
    }
    const handleLimpiar = () => {
        formik.resetForm();   
        setObservaciones("");
    }
    const getGestores= async (rol) => {
        setLoading(true);   
        const query = Buffer.from(JSON.stringify({ idOrganizacion: llaves && llaves['idOrgCaso'], rol: rol, tipoPersona: '0080PROVE00' })).toString('base64');
        const response = await serviceGetGestores(query);
        setGestores(response);
        setLoading(false);
    }
    const getRequisitos = async () => {
        setLoading(true);   
        let query = Buffer.from(JSON.stringify({"idCaso":llaves && llaves['idCaso'], "codRequisito":"225030"})).toString('base64');
        setLoading(true);
        const response = await serviceGetRequisitos(query);
        setLoading(false);

        setRequisitos(response);
    }

    useEffect(() => {
        if (showModal && solicitud) {
            if (solicitud.codTipoInforme == TIPO_INFORME_RAT) {//Informe RAT 
                getGestores('70GESINFRAT');
                getRequisitos();
            } else {
                getGestores('70GESINFMED');
            }
        }
    }, [showModal, solicitud])
    
    const formik = useFormik({
        initialValues: {
            "idCaso": "",
            "idImplicadoCaso": "",
            "idOrganizacion": "",
            "idUsuario": "",
            "gestor":"",
            "observacionesAnalistaCIA": "",
            "accion": "",
            "accionBtn":""
        },
        validationSchema: validationSchemasSolicitarInformeProfesional(),
        onSubmit: (formData) => {

            console.log("formData:", formData);

            try {

                const dataForm = {
                    ...formData
                }
                dataForm['idCaso'] = llaves && llaves['idCaso'];
                dataForm['idOrganizacion'] = llaves && llaves['idOrgCaso'];
                dataForm['accion'] = 2;//Autorizar/Rechazar
                dataForm['solicitud'] = solicitud;
                dataForm['idTrxOrigen'] = idTrxOrigen;

                setLoading(true);
                serviceGestionaSolicitudInforme(dataForm)
                .then((response) => {
                                                
                    setRespuestaGestion(response);
                    handleShowToast(true);
                    setLoading(false);                           
                })
                .catch((error) => {
                    setLoading(false);
                    console.error(error.message);
                    alert(error.message);
                });            
            } catch (error) {
                setLoading(false);
                console.error("error: ", error);
            }
        }
    })

    const [showCarpeta, setShowCarpeta] = useState(false)
    const handleShowCarpeta = () => setShowCarpeta(true)
    const handleCloseCarpeta= () => setShowCarpeta(false)    

    return (
        <Fragment>
            <Modal show={showCarpeta} onHide={handleCloseCarpeta} size="xl">
                <CarpetaDigitalComponent handleClose={handleCloseCarpeta} 
                    idCaso={llaves && llaves['idCaso']}
                    idImplicado={llaves && llaves['idImplicado']}
                    idOrganizacionCaso={llaves && llaves['idOrgCaso']}
                    prototipo={2}            
                />   
            </Modal>
            <LoadingComponent show={loading} />
            <Form onSubmit={formik.handleSubmit}>
                <Card >
                    <Card.Header className='cardHeader'>
                        {(cfg_form && cfg_form["autoriza-informe-titleauto"]) ? cfg_form["autoriza-informe-titleauto"] : 'Autorizar Informe Profesional'}
                    </Card.Header>
                    <Card.Body className='customCard'>
                        <Row>
                            <Col md='2'>
                                <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["autoriza-informe-text-tipoinf"]) ? cfg_form["autoriza-autoriza-text-tipoinf"] : 'Tipo Informe'}
                                </Form.Label>
                                <br></br>
                                <Form.Text className='mb-3'>
                                    {(solicitud && solicitud['tipoInforme']) ? solicitud['tipoInforme'] : null}
                                </Form.Text>
                            </Col>
                            <Col md='4'>
                                <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["autoriza-informe-text-resposol"]) ? cfg_form["autoriza-autoriza-text-resposol"] : 'Responsable Solicita'}
                                </Form.Label>
                                <br></br>
                                <Form.Text className='mb-3'>
                                    {(solicitud && solicitud['responsableSolicita']) ? solicitud['responsableSolicita'] : null}
                                </Form.Text>
                            </Col>
                            <Col md='2'>
                                <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["autoriza-informe-text-fechasol"]) ? cfg_form["autoriza-autoriza-text-fechasol"] : 'Fecha Solicitud'}
                                </Form.Label>
                                <br></br>
                                <Form.Text className='mb-3'>
                                    {(solicitud && solicitud['fecSolicitudFormat']) ? solicitud['fecSolicitudFormat'] : null}
                                </Form.Text>
                            </Col>
                            <Col md='4'>
                                <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["autoriza-informe-cmb-gestores"]) ? cfg_form["autoriza-informe-cmb-gestores"] : 'Gestor Informe Profesional'}
                                </Form.Label>
                                <Form.Select
                                    name='gestor'
                                    value={formik.values.gestor}
                                    onChange={(e) => {
                                        formik.handleChange(e)
                                      }
                                    }>
                                    <option value={""}>Seleccione</option>
                                    {gestores && gestores
                                        .map((i, index) => (<option key={index} value={i.id}>{i.nombre}</option>))
                                    }
                                </Form.Select>
                                {formik.errors.gestor ? (
                                <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.gestor}
                                </Form.Text>
                                ) : (
                                ''
                                )}
                            </Col>
                        </Row>
                        <Row>
                            <Col md="6" >
                                <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["autoriza-informe-text-coment"]) ? cfg_form["autoriza-informe-text-coment"] : 'Comentario Solicitante'}
                                </Form.Label>
                                <br />
                                <Form.Text className='mb-3'>
                                    {(solicitud && solicitud['comentario']) ? solicitud['comentario'] : null}
                                </Form.Text>
                            </Col>
                            {(solicitud && solicitud['codTipoInforme']) && solicitud['codTipoInforme'] == TIPO_INFORME_RAT &&
                                <Col md="5" >
                                    <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>Documentos Requridos</Form.Label>
                                    <Requisitos 
                                        requisitos={requisitos && requisitos} 
                                        recargarRequisitos={getRequisitos}
                                    />           
                                    {formik.errors.valRequisitos ? (
                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                        {formik.errors.valRequisitos}
                                    </Form.Text>
                                    ) : (
                                    ''
                                    )}     
                                </Col>
                            }
                            {(solicitud && solicitud['codTipoInforme']) && solicitud['codTipoInforme'] != TIPO_INFORME_RAT &&
                                <Col md='6'>                                    
                                    <Row>
                                        <Col>
                                            <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                {(cfg_form && cfg_form["autoriza-informe-text-implicado"]) ? cfg_form["autoriza-informe-text-implicado"] : 'Implicado'}
                                            </Form.Label>
                                            <br />
                                            <div>
                                                <Form.Text className='mb-3'>
                                                    {(solicitud && solicitud['rutImplicado']) ? solicitud['rutImplicado'] : null} {" "}                                               
                                                    {(solicitud && solicitud['implicado']) ? solicitud['implicado'] : null}
                                                </Form.Text>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            }
                        </Row>
                        <Row>
                            <Col md="6" >
                                <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                    {(cfg_form && cfg_form["autoriza-informe-text-comentanalista"]) ? cfg_form["solicita-informe-text-comentanalista"] : 'Comentario Analista CIA'}
                                </Form.Label>
                                <br />
                                <Form.Control as="textarea" rows={3} 
                                    onChange={e=>{                    
                                        formik.handleChange(e)
                                        setObservaciones(e.target.value)                                    
                                    }}
                                    name='observacionesAnalistaCIA'                            
                                    value={formik.values.observacionesAnalistaCIA=observaciones}
                                    error={formik.errors.observacionesAnalistaCIA}  
                                />
                                {formik.errors.observacionesAnalistaCIA ? (
                                <Form.Text variant='danger' style={{ color: 'red' }}>
                                    {formik.errors.observacionesAnalistaCIA}
                                </Form.Text>
                                ) : (
                                ''
                                )}
                            </Col>
                        </Row>
                        <Row>
                            <Col md="7" ></Col>                            
                        </Row>
                        <hr style={{ borderTop: '2px solid #04005D' }}></hr>                        
                        <Row className='containerHeader'>
                            <Col className="d-grid d-md-flex justify-content-md-end">
                                <Button style={{ width: '110px', marginRight: '5px' }} variant='outline-info' onClick={handleClose}>
                                    {(cfg_form && cfg_form["autoriza-informe-btncerrar"]) ? cfg_form["autoriza-informe-btncerrar"] : 'Cerrar'}
                                </Button>                                
                                <Button style={{ width: '130px', marginRight: '5px' }} variant='carpeta' onClick={handleShowCarpeta}>
                                    {(cfg_form && cfg_form["autoriza-informe-btncarpeta"]) ? cfg_form["autoriza-informe-btncarpeta"] : 'Documentos'}
                                </Button>
                                <Button 
                                    style={{ width: '110px', marginRight: '5px', color:'#ffffff' }} 
                                    variant='btn btn-info' 
                                    name="accionBtn" value="rechazar" 
                                    type='submit'
                                    onClick={() => formik.setFieldValue("accionBtn", "rechazar")}>
                                    {(cfg_form && cfg_form["autoriza-informe-btnrechazar"]) ? cfg_form["autoriza-informe-btnrechazar"] : 'Rechazar'}
                                </Button>
                                <Button style={{ width: '110px', color: 'white' }} 
                                    variant='solicitar' 
                                    name="accionBtn" 
                                    value="autorizar" 
                                    type='submit'
                                    onClick={() => formik.setFieldValue("accionBtn", "autorizar")}>
                                    {(cfg_form && cfg_form["autoriza-informe-btnautorizar"]) ? cfg_form["autoriza-informe-btnautorizar"] : 'Autorizar'}
                                </Button>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
                <Container>
                    <Row>
                        <Col>
                            {respuestaGestion && 
                                <Mensajes
                                    showToast={showToast}
                                    handleCloseToast={handleCloseToast}
                                    delay={5000}
                                    responseData={respuestaGestion}
                                ></Mensajes>
                            }
                        </Col>
                    </Row>
                </Container>
            </Form>

        <style type='text/css'>
        {`
            .cardHeader {
                background-color: #77789b;
                color: #FFFFFF;
            }
            .containerHeader {
                display: flex;
                justify-content: space-between;
            }
            .customCard {
                padding-top: 0;
                padding-left: 0;
                padding-right: 0;
                padding: 1rem;
            }
            .customHeaderCard {
                background-color: #676999;
                color: #fff;
                font-size: 17px;
                font-weight: 600;
                text-align: center;
                text-decoration: underline;
            }
            .cursor {
                cursor: pointer;
            }
            .btn-carpeta {
                background-color: #F0AD3E;
                color: #FFFFFF;
                width: 140px;                    
            }
            .btn-carpeta:hover{
                background-color:#e1b97f;
                color: #FFFFFF;
            }
            .btn-solicitar {
                background-color: #C14B49;
                color: #FFFFFF;
                width: 140px;
                padding:6px 0px 6px 0px;
            }
            .btn-solicitar:hover{
                background-color:  #F6897E;
                color: #FFFFFF;
            }
        `}
    </style>
    </Fragment>
    )
}

export default Formulario